<template>
  <div class="formWrapper">
    <div class="tabWrapper" v-if="showTab">
      <label
        :class="{ checked: functionType.includes('welfare') }"
        @click.self="clickGA('免費諮詢', '企業福委人資')"
      >
        <input type="radio" v-model="functionType" value="welfare" />
        <span class="checkmark"></span>
        企業福委/人資
      </label>
      <label
        :class="{ checked: functionType === 'beshop_eticket' }"
        @click.self="clickGA('免費諮詢', '電子票券採購')"
      >
        <input type="radio" v-model="functionType" value="beshop_eticket" />
        <span class="checkmark"></span>
        電子票券採購
      </label>
      <label
        :class="{ checked: functionType === 'beshop_purchase' }"
        @click.self="clickGA('免費諮詢', '實體票券商品採購')"
      >
        <input type="radio" v-model="functionType" value="beshop_purchase" />
        <span class="checkmark"></span>
        實體票券/商品採購
      </label>
      <label
        :class="{ checked: functionType.includes('employee') }"
        @click.self="clickGA('免費諮詢', '企業員工')"
      >
        <input type="radio" v-model="functionType" value="employee" />
        <span class="checkmark"></span>
        企業員工
      </label>
    </div>
    <form ref="form" @submit.prevent id="consultForm">
      <div class="row">
        <div class="input-wrap">
          <label>
            <h4>公司名稱</h4>
          </label>
          <input
            class="form-control"
            id="username"
            type="text"
            name="consultForm.comName"
            v-model="consultForm.comName"
            placeholder="請輸入您的公司名稱"
            autocomplete="off"
            :maxlength="64"
          />
          <span class="error-msg" v-if="v$.consultForm.comName.$error"
            >請輸入公司名稱</span
          >
        </div>
        <div class="input-wrap" v-if="functionType === 'welfare'">
          <label>
            <h4>台灣員工數</h4>
          </label>
          <input
            class="form-control"
            id="employeeNum"
            type="number"
            name="consultForm.employeeNum"
            v-model="consultForm.employeeNum"
            placeholder="請輸入台灣員工數"
            autocomplete="off"
          />
          <span class="error-msg" v-if="v$.consultForm.employeeNum.$error"
            >請輸入台灣員工數</span
          >
        </div>
        <div class="input-wrap">
          <label>
            <h4>聯絡人</h4>
          </label>
          <input
            class="form-control"
            type="text"
            name="consultForm.contactName"
            v-model="consultForm.contactName"
            placeholder="請輸入您的姓名"
            :maxlength="20"
          />
          <span class="error-msg" v-if="v$.consultForm.contactName.$error"
            >請輸入您的姓名</span
          >
        </div>
        <div class="input-wrap">
          <label>
            <h4>聯絡電話</h4>
          </label>
          <input
            class="form-control"
            type="text"
            name="consultForm.tel"
            v-model="consultForm.tel"
            placeholder="請輸入您的手機或公司電話"
            :maxlength="20"
          />
          <span
            class="error-msg"
            v-if="
              v$.consultForm.tel.$error && v$.consultForm.tel.required.$invalid
            "
            >請輸入您的手機或公司電話，範例：02-3322-3866#200</span
          >
          <span
            class="error-msg"
            v-if="v$.consultForm.tel.phoneNumRules.$invalid"
            >聯絡電話只能填寫0-9與特殊符號#-</span
          >
        </div>
        <div class="input-wrap">
          <label>
            <h4>電子郵件</h4>
          </label>
          <input
            class="form-control"
            id="email"
            type="email"
            name="consultForm.mail"
            v-model="consultForm.mail"
            placeholder="請輸入您的Email"
            autocomplete="off"
            @change="accountExists = false"
          />
          <span
            class="error-msg"
            v-if="
              v$.consultForm.mail.$error &&
              v$.consultForm.mail.required.$invalid
            "
            >請輸入您的Email</span
          >
          <span class="error-msg" v-if="v$.consultForm.mail.email.$invalid"
            >Email格式錯誤</span
          >
        </div>

        <template v-if="functionType === 'welfare'">
          <!-- 目前福利發放方式 Start -->
          <div class="input-wrap">
            <label>
              <h4>目前福利發放方式(可複選)</h4>
            </label>
            <div class="checkbox-container">
              <div
                class="checkbox-wrap"
                v-for="option in currentAllotOptions"
                :key="option.id"
              >
                <label class="checkbox-item" :for="option.value">
                  <input
                    type="checkbox"
                    :id="option.value"
                    :name="option.value"
                    :value="option.id"
                    v-model="consultForm.currentAllot"
                  />
                  <span class="checkmark"></span>
                  {{ option.label }}
                </label>
              </div>
              <div class="checkbox-wrap offerType">
                <label class="checkbox-item" for="others">
                  <input
                    type="checkbox"
                    id="others"
                    name="others"
                    value="6"
                    v-model="consultForm.currentAllot"
                  />
                  <span class="checkmark"></span>
                  其他
                </label>
                <div
                  v-if="consultForm.currentAllot.includes('6')"
                  style="width: calc(100% - 40px)"
                >
                  <input
                    class="form-control offerType-input"
                    name="consultForm.offerType"
                    v-model="consultForm.offerType"
                    placeholder="請輸入發放方式"
                    :maxlength="50"
                  />
                  <div class="error-msg" v-if="v$.consultForm.offerType.$error">
                    請輸入發放方式
                  </div>
                </div>
              </div>
            </div>
            <span class="error-msg" v-if="v$.consultForm.currentAllot.$error">
              請選擇目前福利發放方式
            </span>
          </div>
          <!-- 目前福利發放方式 End -->

          <!-- 如何得知福利網 Start -->
          <div class="input-wrap">
            <label>
              <h4>如何得知福利網</h4>
            </label>
            <select
              class="form-control"
              v-model="consultForm.howToKnowWelfare"
              @change="howToKnowWelfareChange($event)"
            >
              <option value="">請選擇</option>
              <option
                :value="howToKnow.id"
                v-for="howToKnow in howToKnowOptionsWelfare"
                :key="howToKnow.id"
              >
                {{ howToKnow.value }}
              </option>
            </select>
            <span
              class="error-msg"
              v-if="v$.consultForm.howToKnowWelfare.$error"
              >請選擇得知管道</span
            >
          </div>
          <div class="input-wrap" v-if="showTypeHowToKnowWelfare">
            <input
              class="form-control"
              type="text"
              name="consultForm.typeHowToKnow"
              v-model="consultForm.typeHowToKnowWelfare"
              placeholder="請輸入得知管道"
              :maxlength="50"
            />
            <span
              class="error-msg"
              v-if="v$.consultForm.typeHowToKnowWelfare.$error"
              >請輸入得知管道</span
            >
          </div>
          <!-- 如何得知 End -->
        </template>

        <template
          v-if="
            functionType === 'beshop_eticket' ||
            functionType === 'beshop_purchase'
          "
        >
          <!-- 如何得知禮贈平台 Start -->
          <div class="input-wrap">
            <label>
              <h4>如何得知此服務</h4>
            </label>
            <select
              class="form-control"
              v-model="consultForm.howToKnow"
              @change="howToKnowChange($event)"
            >
              <option value="">請選擇</option>
              <option
                :value="howToKnow.from"
                v-for="(howToKnow, idx) in howToKnowOptions"
                :key="idx"
              >
                {{ howToKnow.from }}
              </option>
              <option value="other">其他</option>
            </select>
            <span class="error-msg" v-if="v$.consultForm.howToKnow.$error"
              >請選擇得知管道</span
            >
          </div>
          <div class="input-wrap" v-if="showTypeHowToKnow">
            <input
              class="form-control"
              type="text"
              name="consultForm.typeHowToKnow"
              v-model="consultForm.typeHowToKnow"
              placeholder="請輸入得知管道"
              :maxlength="50"
            />
            <span class="error-msg" v-if="v$.consultForm.typeHowToKnow.$error"
              >請輸入得知管道</span
            >
          </div>
          <!-- 如何得知 End -->

          <!-- 您想了解的是 Start -->
          <div class="input-wrap">
            <label>
              <h4 v-if="functionType === 'beshop_eticket'">
                您的採購目的是...
              </h4>
              <h4 v-if="functionType === 'beshop_purchase'">
                想要採購的商品 ( {{ purchaseWordCnt }} / 150 字)
              </h4>
            </label>
            <select
              class="form-control"
              v-model="consultForm.wantToKnow"
              @change="wantToKnowChange($event)"
              v-if="functionType === 'beshop_eticket'"
            >
              <option value="">請選擇</option>
              <option
                :value="wantToKnow.target"
                v-for="(wantToKnow, idx) in wantToKnowOptions"
                :key="idx"
              >
                {{ wantToKnow.target }}
              </option>
              <option value="other">其他</option>
            </select>
            <span class="error-msg" v-if="v$.consultForm.wantToKnow.$error"
              >請輸入得知管道</span
            >
          </div>
          <div class="input-wrap" v-if="showTypeWantToKnow">
            <input
              class="form-control"
              type="text"
              name="consultForm.typeWantToKnow"
              v-model="consultForm.typeWantToKnow"
              placeholder="請輸入想了解的內容"
              :maxlength="50"
            />
            <span class="error-msg" v-if="v$.consultForm.typeWantToKnow.$error"
              >請輸入想了解的內容</span
            >
          </div>

          <div class="input-wrap" v-if="showTypeNumOfEmployees">
            <input
              class="form-control"
              type="text"
              name="typeNumOfEmployees"
              v-model="typeNumOfEmployees"
              placeholder="請輸入台灣員工人數"
              :maxlength="6"
            />
            <span class="error-msg" v-if="v$.typeNumOfEmployees.$error"
              >請輸入台灣員工人數</span
            >
          </div>

          <div class="input-wrap" v-if="functionType === 'beshop_purchase'">
            <textarea
              id="purchase-textarea"
              class="form-control"
              name="consultForm.typeWantToKnowBeshopPurchase"
              v-model="consultForm.typeWantToKnowBeshopPurchase"
              placeholder="請簡述您想採購的商品名稱及數量"
              rows="4"
              :maxlength="150"
              @input="updateWordCount"
            />
            <span
              class="error-msg"
              v-if="v$.consultForm.typeWantToKnowBeshopPurchase.$error"
            >
              請輸入商品名稱及數量
            </span>
          </div>

          <!-- 您想了解的是 End -->
        </template>

        <div class="input-wrap">
          <div class="col-xs-12 checkbox">
            <label>
              <input
                type="checkbox"
                name="checkPersonalInfo"
                v-model="checkPersonalInfo"
              />我同意PayEasy的<a
                href="https://www.payeasy.com.tw/HappyS/privacy.html"
                target="_blank"
                rel="noopener noreferrer"
                >隱私權聲明</a
              >
            </label>
            <div class="error-msg" v-if="v$.checkPersonalInfo.$error">
              請勾選
            </div>
          </div>
        </div>
        <button
          type="submit"
          class="btn-consult"
          :disabled="submitting"
          @click.prevent="submit"
        >
          <span>{{ submitting ? "送出中…" : "送出" }}</span>
        </button>
      </div>
    </form>
    <AlertModal v-if="showAlert" :message="alertMsg" @closeModal="onAlertClose" />
  </div>
</template>

<script>
import { useVuelidate } from "@vuelidate/core";
import {
  required,
  requiredIf,
  email,
  helpers,
  sameAs,
} from "@vuelidate/validators";
import axios from "axios";
import AlertModal from "./AlertModal.vue";

const apiClientBEShop = axios.create({
  baseURL: "https://www.payeasy.com.tw/",
  headers: {
    "Content-Type": "application/json",
  },
});
const apiClient = axios.create({
  headers: { "Content-Type": "multipart/form-data" },
});
const phoneNumRules = helpers.regex(/^[0-9#-]+$/);

const RECAPTCHA_V3_KEY = "6LewgHcbAAAAAIKyrfjJiFW03IeidTYYZEI3T8ZV";
const RECAPTCHA_SRC = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_V3_KEY}`;
const HOME_URL =
  "https://www.payeasy.com.tw/PWelfareWeb/COMMON/invitation/index.html";

export default {
  name: "ConsultPage",
  setup() {
    return { v$: useVuelidate() };
  },
  components: { AlertModal },
  data: function () {
    return {
      showTab: true,
      consultForm: {
        contactName: "",
        employeeNum: "",
        comName: "",
        tel: "",
        mail: "",
        howToKnow: "",
        typeHowToKnow: "",
        howToKnowWelfare: "",
        typeHowToKnowWelfare: "",
        typeWantToKnowBeshopPurchase: "",
        wantToKnow: "",
        typeWantToKnow: "",
        offerType: "",
        currentAllot: [],
      },
      sentModal: false,
      modalMessage: {
        title: "",
        content: "",
        media: "",
      },
      checkPersonalInfo: null,
      mailExists: false,
      showTypeWantToKnow: false,

      showTypeHowToKnow: false,
      showTypeHowToKnowWelfare: false,
      showTypeNumOfEmployees: false,
      wantToKnowOptions: [],
      howToKnowOptions: [],
      functionType: "welfare",
      howToKnowOptionsWelfare: [
        { id: 0, value: "網頁關鍵字搜尋 (傳統搜尋引擎)" },
        { id: 5, value: "AI 智能對話與推薦 (生成式 AI 問答)" },
        { id: 1, value: "實體DM介紹" },
        { id: 2, value: "其他企業介紹" },
        { id: 3, value: "自己或同事曾經使用過" },
        { id: 4, value: "其他" },
      ],
      currentAllotOptions: [
        { id: 0, value: "cash", label: "現金" },
        { id: 1, value: "gift", label: "禮品" },
        { id: 2, value: "voucher", label: "禮券(紙本)" },
        { id: 3, value: "eVoucher", label: "禮券(電子)" },
        { id: 4, value: "tour", label: "團體旅遊" },
        { id: 5, value: "travelSubsidy", label: "個人旅遊補助" },
      ],
      showAlert: false,
      alertMsg: "",
      redirectAfterClose: false,
      submitting: false,
      typeNumOfEmployees: "",
      purchaseWordCnt: 0,
    };
  },
  validations() {
    return {
      consultForm: {
        contactName: { required },
        comName: { required },
        tel: { required, phoneNumRules },
        mail: { required, email },
        howToKnow: {
          required: requiredIf(function () {
            return (
              this.functionType === "beshop_eticket" ||
              this.functionType === "beshop_purchase"
            );
          }),
        },
        typeHowToKnow: {
          required: requiredIf(function () {
            return this.showTypeHowToKnow;
          }),
        },
        howToKnowWelfare: {
          required: requiredIf(function () {
            return this.functionType === "welfare";
          }),
        },
        typeHowToKnowWelfare: {
          required: requiredIf(function () {
            return this.showTypeHowToKnowWelfare;
          }),
        },
        wantToKnow: {
          required: requiredIf(function () {
            return this.functionType === "beshop_eticket";
          }),
        },
        typeWantToKnow: {
          required: requiredIf(function () {
            return this.showTypeWantToKnow;
          }),
        },
        typeWantToKnowBeshopPurchase: {
          required: requiredIf(function () {
            return this.functionType === "beshop_purchase";
          }),
        },
        employeeNum: {
          required: requiredIf(function () {
            return this.functionType === "welfare";
          }),
        },
        offerType: {
          required: requiredIf(function () {
            return this.consultForm.currentAllot.includes("6");
          }),
        },
        currentAllot: {
          required: requiredIf(function () {
            return this.functionType === "welfare";
          }),
        },
      },
      checkPersonalInfo: { sameAs: sameAs(true) },
      typeNumOfEmployees: {
        required: requiredIf(function () {
          return this.showTypeNumOfEmployees;
        }),
      },
    };
  },
  created() {
    const urlParams = new URLSearchParams(window.location.search);
    const type = urlParams.get("type")
      ? urlParams.get("type").toLowerCase()
      : "";
    if (type === "beshop") this.functionType = "beshop_eticket";
    this.loadOptions();
    this.loadRecaptcha();
  },
  mounted() {
    if (this.$route.query.tab) {
      this.showTab = false;
      if (this.$route.query.tab === "1") {
        this.functionType = "welfare"; // 企業福委/人資
      } else if (this.$route.query.tab === "2") {
        this.functionType = "beshop_eticket"; // 電子票券採購
      } else if (this.$route.query.tab === "3") {
        this.functionType = "beshop_purchase"; // 實體票券/商品採購
      } else {
        this.showTab = true;
        this.functionType = "welfare";
      }
    }
  },
  methods: {
    loadOptions() {
      let vm = this;
      apiClientBEShop
        .get("beshop/marketing/consultSelectOption.json")
        .then((response) => {
          vm.wantToKnowOptions = response.data.options[0].wantToKnow;
          vm.howToKnowOptions = response.data.options[1].howToKnow;
        });
    },
    howToKnowChange(event) {
      let vm = this;
      if (event.target.value === "other") {
        vm.showTypeHowToKnow = true;
      } else {
        vm.showTypeHowToKnow = false;
      }
    },
    howToKnowWelfareChange(event) {
      let vm = this;
      if (event.target.value === "4") {
        vm.showTypeHowToKnowWelfare = true;
      } else {
        vm.showTypeHowToKnowWelfare = false;
      }
    },
    wantToKnowChange(event) {
      let vm = this;
      if (event.target.value === "other") {
        vm.showTypeWantToKnow = true;
        vm.showTypeNumOfEmployees = false;
      } else if (event.target.value === "員工福利") {
        vm.showTypeNumOfEmployees = true;
        vm.showTypeWantToKnow = false;
      } else {
        vm.showTypeNumOfEmployees = false;
        vm.showTypeWantToKnow = false;
      }
    },
    updateWordCount() {
      this.purchaseWordCnt =
        this.consultForm.typeWantToKnowBeshopPurchase.length;
    },
    async submit() {
      if (this.submitting) return;

      await this.v$.$validate();
      if (this.v$.$error) return;

      this.submitting = true;

      let gtoken;
      try {
        gtoken = await this.getRecaptchaToken();
      } catch (e) {
        this.alertMsg = "驗證未完成，請稍後再試";
        this.showAlert = true;
        this.submitting = false;
        return;
      }

      let postForm = Object.assign({}, this.consultForm);

      if (postForm.howToKnow === "other") {
        postForm.howToKnow = "其他：" + postForm.typeHowToKnow;
      }

      if (postForm.wantToKnow === "other") {
        postForm.wantToKnow = "其他：" + postForm.typeWantToKnow;
      } else if (postForm.wantToKnow === "員工福利") {
        postForm.wantToKnow =
          postForm.wantToKnow + "：" + this.typeNumOfEmployees + " 人";
      }

      if (this.functionType === "beshop_purchase") {
        postForm.wantToKnow =
          "想要採購的商品 : " + postForm.typeWantToKnowBeshopPurchase;
      }

      if (
        this.functionType === "beshop_eticket" ||
        this.functionType === "beshop_purchase"
      ) {
        apiClientBEShop
          .post("BEShopWebServices/api/serving/consult/save", {
            ...postForm,
            gtoken,
            bqReferer:
              this.functionType === "beshop_eticket"
                ? "consultForm-eticket"
                : "consultForm-purchase",
          })
          .then((res) => {
            if (res.status !== 200) {
              this.alertMsg = "系統異常，請稍後再試";
              this.showAlert = true;
              return;
            }
            const body = res.data;
            const isEmptyBody =
              body == null ||
              body === "" ||
              (typeof body === "object" && Object.keys(body).length === 0);
            if (isEmptyBody || body.status === 200) {
              this.alertMsg = "登記表單成功";
              this.showAlert = true;
              this.redirectAfterClose = true;
              this.clickGA("禮贈送出申請", "");
            } else {
              this.alertMsg = "系統異常，請稍後再試";
              this.showAlert = true;
            }
          })
          .catch(this.handleSubmitError)
          .finally(() => {
            this.submitting = false;
          });
      } else if (this.functionType === "welfare") {
        apiClient
          .post("https://www.payeasy.com.tw/PUBLICPcash/actJoinWelfare.do", {
            comName: this.consultForm.comName,
            empSum: this.consultForm.employeeNum,
            benefitName: this.consultForm.contactName,
            benefitPhone: this.consultForm.tel,
            benefitMail: this.consultForm.mail,
            checkBonusString: this.consultForm.currentAllot.toString(),
            bonusOther: this.consultForm.offerType,
            checkKnowList: this.consultForm.howToKnowWelfare,
            knowOther: this.consultForm.typeHowToKnowWelfare,
            gtoken,
          })
          .then((res) => {
            if (res.status !== 200) {
              this.alertMsg = "系統異常，請稍後再試";
              this.showAlert = true;
              return;
            }
            if (res.data.status === 200) {
              this.alertMsg = res.data.result;
              this.showAlert = true;
              this.redirectAfterClose = true;
              this.clickGA("福利網送出申請", "");
            } else if (res.data.status === 401) {
              this.alertMsg = res.data.result || "系統異常，請稍後再試";
              this.showAlert = true;
            } else {
              this.alertMsg = "系統異常，請稍後再試";
              this.showAlert = true;
            }
          })
          .catch(this.handleSubmitError)
          .finally(() => {
            this.submitting = false;
          });
      }
    },
    async resetConsultForm() {
      this.consultForm = await {
        contactName: "",
        employeeNum: "",
        comName: "",
        tel: "",
        mail: "",
        howToKnow: "",
        typeHowToKnow: "",
        howToKnowWelfare: "",
        typeHowToKnowWelfare: "",
        typeWantToKnowBeshopPurchase: "",
        wantToKnow: "",
        typeWantToKnow: "",
        offerType: "",
        currentAllot: [],
      };
      this.showTypeWantToKnow = false;
      this.showTypeHowToKnow = false;
      this.showTypeHowToKnowWelfare = false;
      this.showTypeNumOfEmployees = false;
      this.checkPersonalInfo = await null;
      this.typeNumOfEmployees = "";
      this.typeWantToPurchase = "";
      await this.v$.$reset();
    },
    clickGA(slot, slot_detail) {
      window.dataLayer.push({
        event: "click_button",
        main_page: "PC application",
        slot,
        slot_detail,
      });
    },
    loadRecaptcha() {
      if (document.getElementById("recaptcha-v3-script")) return;
      const script = document.createElement("script");
      script.id = "recaptcha-v3-script";
      script.src = RECAPTCHA_SRC;
      document.head.appendChild(script);
    },
    getRecaptchaToken() {
      return new Promise((resolve, reject) => {
        const grecaptcha = window.grecaptcha;
        if (!grecaptcha || !grecaptcha.execute || !grecaptcha.ready) {
          reject(new Error("recaptcha not ready"));
          return;
        }
        grecaptcha.ready(() => {
          grecaptcha
            .execute(RECAPTCHA_V3_KEY, { action: "submit" })
            .then((token) => {
              if (token) resolve(token);
              else reject(new Error("empty token"));
            })
            .catch(reject);
        });
      });
    },
    handleSubmitError(error) {
      // 禮贈 reCAPTCHA 分數過低回 HTTP 400 + body.status 400，顯示後端 message；其餘為網路層錯誤
      const res = error && error.response;
      if (res && res.status === 400 && res.data && res.data.status === 400) {
        this.alertMsg = res.data.message || "系統異常，請稍後再試";
      } else {
        this.alertMsg = "系統異常，請稍後再試";
      }
      this.showAlert = true;
    },
    onAlertClose() {
      this.showAlert = false;
      if (this.redirectAfterClose) {
        window.location.href = HOME_URL;
      }
    },
  },
  watch: {
    functionType(newV, oldV) {
      this.resetConsultForm();

      if (newV === "employee") {
        window.open(
          "https://www.payeasy.com.tw/Cas/login?service=https%3A%2F%2Fwww.payeasy.com.tw%2F"
        );
        setTimeout(() => {
          this.functionType = oldV;
        });
      }
    },
  },
};
</script>
